module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Abbreviations and Acronyms")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("AFP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Agence France-Press")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Amtorg")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("American-Soviet Trading Corporation, first Soviet trade company established in New York")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Arcos")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("All-Russian Co-operative Society, Anglo-Russian trade organisation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("BKP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("B’lgarska Komunisticheska Partiya (‘Bulgarian Communist Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("BRD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bundesrepublik Deutschland (‘Federal Republic of Germany’), West Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("BVT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bundesamt für Verfassungsschutz und Terrorismusbe kämpfung (‘Federal Office For the Protection of the Consitution’), Austrian security agency until 2021")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CEDA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Confederación Nacional de Derechas Autónomas (‘Confederation of the Autunomous Right’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centre")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("HQ of the KGB, their predecessors and their successor SVR, previously Lubyanka, now Yasenevo a.k.a. Les (‘Forest’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cheka")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chrezvychainaya Komissiya (‘Extraordinary Commission for Combating Counter-revolution and Sabotage’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Central Intelligence Agency, the Agency, USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Confederación Nacional del Trabajo (‘National Confederation of Labour’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Comintern")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Communist International, also known as the Third International (1919–43)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CPGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Communist Party of Great Britain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CPSU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Communist Party of the Soviet Union")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CPUSA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Communist Party of the USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CRIMINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Criminal Intelligence")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DDR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deutsche Demokratische Republik (‘German Democratic Republic’), East Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DEDIDE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Departamento Especial de Información del Estado, one of several Spanish Republican intelligence services")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DGS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dirección General de Seguridad (‘Directorate General of Security’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v("DGSE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Direction Générale de la Sécurité Extérieure (‘General Directorate for External Security’), foreign intelligence agency, France")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DGSI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Direction Générale de la Sécurité Intérieure (‘General Directorate for Internal Security’), French security agency responsible for counter-espionage, counter-terrorism, countering cybercrime and any other homeland security threats")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Defence Intelligence, military intelligence, part of the Ministry of Defence (since 2009), UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DIS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Defence Intelligence Staff (1964–2009), successor of military intelligence (DMI), Air Intelligence (AI) and Naval Intelligence (NID), UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DLB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("dead letter box")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DRG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Diversionno-razvedyvatelnaya gruppa (‘sabotage and reconnaissance group’), USSR/RF")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DSN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Direktion Staatsschutz und Nachrichtendienst (‘Directorate for State Protection and Intelligence Service’), since 2021 – part of the General Directorate for Public Security of the Interior Ministry and successor to the BVT, Austria")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("DST")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Direction de la Surveillance du Territoire (‘Directorate of Territorial Surveillance’), French counter-intelligence and security service (1944–2008)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ECCI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Executive Committee of the Communist International – the governing authority of the Comintern between the World Congresses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ECHELON")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Worldwide SIGINT collection and analysis programme operated by the NSA assisted by appropriate government agencies of Australia, Canada, New Zealand and the UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ELINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Electronic intelligence’, covert intelligence gathering by electronic means")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("EM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Estado Mayor (‘General Staff’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FAI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Federación Anarquista Ibérica (‘Iberian Anarchist Federation’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FBI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Federal Bureau of Investigations, the Bureau, USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FCD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("First Chief Directorate (see PGU), KGB’s foreign intelligence branch")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FCDO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Foreign, Commonwealth and Development Office, UK FCO Foreign and Commonwealth Office, UK (from 1968 to September 2020). It merged with the Department for International Development to create FCDO")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v("FI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fourth International, revolutionary socialist organisation of Trotskyists")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Foreign Office, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FSB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Federalnaya Sluzhba Bezopasnosti (‘Federal Security Service’), RF")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FSO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Federalnaya Sluzhba Okhrany (‘Federal Protection Service’), RF")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("FVEY")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Five Eyes alliance is an intelligence-sharing agreement between Great Britain and the USA with Australia, Canada and New Zealand")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GC&CS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Government Code and Cipher School, UK (until 1946)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GCHQ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Government Communications Headquarters, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GPU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gosudarstvennoe Politicheskoe Upravlenie (‘State Political Directorate’), USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GRU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Glavnoe Razvedupravlenie, Soviet and Russian Military Intelligence")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GUGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Glavnoe Upravlenie Gosudarstvennoi Bezopasnosti (‘Chief Directorate of State Security’), USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GULAG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Glavnoe Upravlenie Lagerei (‘Chief Directorate of Corrective Labour Camps’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GUPVO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Glavnoe Upravlenie Pogranichnoi i Vnutrennei Okhrany (‘Chief Directorate of the Border Guards and Internal Troops’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("HUMINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Human intelligence (obtained from human sources)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ILS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("International Lenin School, Moscow (1926–91)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("INO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inostrannyi Otdel (‘Foreign Intelligence Department’), Cheka-OGPU, 1920–34")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("INS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Immigration and Naturalisation Service, USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("JIC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joint Intelligence Committee, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kempeitai")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Military Police Corps, Japanese intelligence and counter-intelligence service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Komitet Gosudarstvennoi Bezopasnosti (‘Committee for State Security’), USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Komitet Informatsyi (‘Committee of Information’), Soviet foreign intelligence agency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KIM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kommunisticheskii International Molodiozhy (‘Communist International of Youth’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KJVD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kommunistischer Jugend Verband Deutschlands (‘The Young Communist League of Germany’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KPD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kommunistische Partei Deutschlands (‘Communist Party of Germany’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _vm._v("KPÖ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kommunistische Partei Österreichs (‘Austrian Communist Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KRO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kontr-razvedyvatelnyi otdel (‘Counter-intelligence department’), OGPU, until 1930")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KSČ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Komunistická strana Československa, Czech and Slovak Communist Party")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("KUNMZ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kommunistichesky Universitet Natsionalnykh Menshinstv Zapada (‘The Communist University of the National Minorities of the West’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ministerstvo Gosudarstvennoi Bezopasnosti (‘Ministry of State Security’), USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MI5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("British security service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MI6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Alternative designation for SIS, British foreign intelligence service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MI1c")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secret Intelligence Service, predecessor of MI6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MID")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Military Intelligence Division, until March 1942 under the General Staff of the US Army")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MBP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ministerstwo Bezpieczeństwa Publicznego, the Ministry of Public Security of Poland")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MOPR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mezhdunarodnaya Organisatsyia Pomoschi Rabochim (‘International Workers Aid Organisation’), better known as International Red Aid, Comintern/USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MOTsR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Monarkhicheskaya Organisatsyia Tsentralnoi Rossii (‘Monarchist Organisation of Central Russia’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MVD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ministerstvo Vnutrennikh Del (‘Ministry of Internal Affairs’), USSR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NCSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("National Cyber Security Centre, UK, established in 2016 as part of the GCHQ, located in London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NKGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Narodnyi Komissariat Gosudarstvennoi Bezopasnosti (‘People’s Commissariat for State Security’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NKID")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Narodnyi Komissariat Inostrannykh Del (‘People’s Commissariat for Foreign Affairs’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NKVD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Narodnyi Komissariat Vnutrennikh Del (‘People’s Commissariat for Internal Affairs’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NKVT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Narodnyi Komissariat Vneshnei Torgovli (People’s Commissariat for Foreign Trade’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NSA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("National Security Agency, USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ÖGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Österreichischer Gewerkschaftsbund (‘Austrian Trade-Union Federation’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OGPU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ob’edinennoe Glavnoe Politicheskoe Upravlenie (‘Unified Main Political Directorate’), Soviet intelligence and security service, successor of the VcheKa")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("OKDVA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Osobaya Krasnoznamyonnaya Dalnevostochnaya Armiya (‘Special Red-Banner Far Eastern Army’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Okhrana")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tsarist security service, Russian Empire, 1881–1917")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OKW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oberkommando der Wehrmacht, Supreme Command of the German Armed Forces")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OKW/Chi")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oberkommando der Wehrmacht Chiffrierabteilung, Signal Intelligence Branch of the Supreme Command of the German Armed Forces")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OMS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Otdel Mezhdunarodnykh Svyazei (‘International Liaison Department’), the intelligence branch of the Comintern")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OMSBON")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Otdelnyi Motostrelkovyi Batalion Osobogo Naznacheniya (‘Special Motorised Battalion’), NKVD")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OSINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Open-source intelligence, information collected from publicly-available sources")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OSS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Office of Strategic Services, USA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OUN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Organisation of Ukrainian Nationalists")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("OVRA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Organizzazione per la Vigilanza e la Repressione dell’Antifascismo (‘Organisation for Vigilance and Repression of Anti-Fascism’), Italy")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("PCE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Partido Comunista de España (‘Spanish Communist Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("PCF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Parti Communiste Français (‘French Communist Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("PCM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Partido Comunista Mexicano (‘Mexican Communist Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("POUM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Partido Obrero de Unificación Marxista (‘Workers’ Party of Marxist Unification’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("PSOE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Partido Socialista Obrero Español (‘Spanish Socialist Workers’ Party’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("PSUC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Partit Socialista Unifacat de Catalunya")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RAF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Royal Air Force, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Russian Federation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RKKA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Raboche-Krestyanskaya Krasnaya Armiya (‘The Workers-Peasants Red Army’), Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RSDLP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Russian Special Democratic Labour Party, a socialist political party founded in March 1898 in Minsk, then part of the Russian Empire")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RSHA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Reichssicherheitshauptamt, the Chief Directorate of Security of Nazi Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ROVS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rossiisky Obschevoiskovoi Soyuz (‘Russian Combined Services Union’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Razvedupr, Soviet military intelligence, later GRU")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("RUSI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Royal United Services Institute for Defence and Security Studies, a British think tank founded in 1831. At "), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v("the time of writing RUSI was chaired by William Hague, Baron Hague of Richmond, who used to serve as Secretary of State for Foreign and Commonwealth Affairs (2010–14), with Vice Chairman Sir John Scarlett, former chairman of the Cabinet Office Joint Intelligence Committee (2001–04) and Chief of SIS (2004–09)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SAJ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sozialistische Arbeiter-Jugend (‘Socialist Workers Youth’), Austria, Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Służba Bezpieczeństwa, Polish security and intelligence service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SBU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sluzhba Bezpeky Ukrayiny, the Security Service of Ukraine SCD Second Chief Directorate, KGB’s internal security branch SDECE Service de Documentation Extérieure et de Contre-Espionnage (‘External Documentation and Counter-Espionage Service’), French foreign intelligence service, 1944–82")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Second International")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Organisation of socialist and labour parties (1889–1916)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SGON")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spetsyalnaya Gruppa Osobogo Naznacheniya (‘Special Group for Special Purposes’), NKVD")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SIGINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Signals intelligence (derived from interception and analysis of signals)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SIM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Servicio de Información Militar, Spanish Republican military counter-intelligence service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SIS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secret Intelligence Service, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SNK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sovet Narodnykh Komissarov, Council of People’s Commissars, Soviet Russia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOCMINT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Social Media Intelligence")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Special Operations Executive, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SPEKO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spetsyalnyi kriptograficheskii otdel OGPU, Special Cryptographic Department")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spetsnaz")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Special Forces, USSR/RF")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Socialist Revolutionary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sluzhba Svyazi (‘Communication Service’), predecessor of the OMS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Schutzstaffel, paramilitary organisation in Nazi Germany (1925–45)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SSOD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soyuz Sovetskikh Obshchestv Druzhby i Kulturnoi Svyazi s Zarubezhnymi Stranami (‘Union of Soviet Societies for Friendship and Cultural Relations with Foreign Countries’), KGB front")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v("S&T")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scientific & Technical Intelligence")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("StaPo")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Staatspolizei, Austrian security police (until 2002)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stasi")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Common name for MfS, Ministerium für Staatssicherheit (‘Ministry for State Security’), DDR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("StB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Státní bezpečnost, Czechoslovak security and intelligence service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("SVR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sluzhba Vneshnei Razvedki (‘Foreign Intelligence Service of Russia’), also known by its Russian acronym as PGU")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("TUC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trade Union Congress, UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("UGT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unión General de Trabajadores (‘General Union of Workers’), Spain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("UKUSA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Originally the UK-USA agreement for joint signal intercept networks between the GCHQ and NSA at the beginning of the Cold War, it has developed into a multilateral agreement for cooperation in signals intelligence between the Five Eyes (FVEY)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ULTRA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wartime signals intelligence obtained by breaking high-level encrypted enemy radio and teleprinter communications, GC&CS/UK")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("UME")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unión Militar Española (‘Spanish Military Union’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("UNIT 8200")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Israeli equivalent of the British GCHQ and American NSA – a signals intelligence unit, part of Israeli Military Intelligence (Aman), that also controls cryptography and cryptanalysis. According to some experts, it is probably the foremost technical intelligence agency in the world")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("UPA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ukraińska Powstańcza Armia (‘The Ukrainian Insurgent Army’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("VChKa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("All-Russian Cheka, the immediate successor of the Cheka and predecessor of the GPU-OGPU")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("VOKS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vsesoyuznoe Obschestvo Kulturnoi Svyazi (s zagranitsei), All-Union Society for Cultural Relations (with foreign countries), NKVD front")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("WOSTWAG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("West-East-European Trade Exchange Joint Stock Society, legitimate trade organisation and Soviet military intelligence front with head office in Paris and branches in Berlin, New York, Ulan Bator, Guangzhou and Tientsin (Tianjin)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Z Organisation")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Top-secret, semi-autonomous intelligence organisation within SIS, set up and headed by Lieutenant Colonel Claude Dansey, 1936–45")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea225f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbreviations.vue
// module id = 84
// module chunks = 0